export function create() {
    return {
        center: { x: 0, y: 0, z: 0 },
        normal: { x: 0, y: 0, z: 1 },
        radius: 1,
    };
}
export function copy(self, other) {
    self.center.x = other.center.x;
    self.center.y = other.center.y;
    self.center.z = other.center.z;
    self.normal.x = other.normal.x;
    self.normal.y = other.normal.y;
    self.normal.z = other.normal.z;
    self.radius = other.radius;
}
